// AgentAvatar — the agent presence circle from the landing HeroCanvas
// (company/packages/landing/components/HeroCanvas.js _agentAvatar), promoted
// to shared per Nika 2026-06-12 ("show agent avatar that we use in landing —
// you can also move it to shared AgentAvatar — and reuse it here"): a yellow
// circle wearing the robot glyph as a CSS mask, so the glyph punches through
// in the surface color. Size by overriding boxSize; colors are DS tokens
// (the landing keeps its cv* palette locally).

// Robot glyph (antenna + head + two eye holes via even-odd), inlined as a
// data-URI for use as a CSS mask.
const ROBOT_SVG =
  "url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><circle cx='12' cy='2.6' r='1.3' fill='black'/><rect x='11.3' y='2.8' width='1.4' height='3.2' fill='black'/><path fill='black' fill-rule='evenodd' d='M8 5.8h8a4 4 0 0 1 4 4v5.4a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V9.8A4 4 0 0 1 8 5.8ZM9.2 10.2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4ZM14.8 10.2a1.7 1.7 0 1 0 0 3.4 1.7 1.7 0 0 0 0-3.4Z'/></svg>\")"

export const AgentAvatar = {
  tag: 'span',
  flow: 'x',
  align: 'center center',
  boxSize: 'Z1 Z1',
  round: '50%',
  flexShrink: '0',
  background: 'yellow',

  Bot: {
    tag: 'span',
    width: '66%',
    height: '66%',
    background: 'document',
    // FLAT props, never `style:` — an inline style block is applied with
    // setProperty and gets no -webkit- twin, while a flat mask longhand's class
    // rule carries both spellings (atomic VENDOR_TWINS).
    maskImage: ROBOT_SVG,
    maskSize: 'contain',
    maskRepeat: 'no-repeat',
    maskPosition: 'center'
  }
}
